'use strict';

var i={size_48:"48px",size_99:"99px",size_90:"90px",size_84:"84px",size_100_percent:"100%"},n=e=>{let s={backgroundColor:e.background_surface_default_surface_secondary,borderRadius:e.spacing_8,imageHeight:i.size_48,imagePadding:e.spacing_10,textMarginBottom:e.spacing_12};return {variants:{desktop:{...s,height:i.size_99,width:i.size_90},msite:{...s,height:i.size_84,width:i.size_100_percent}}}};

exports.a = n;
